module.exports = __webpack_public_path__ + "static/SphereViewCarouselcircle-559818af29d5f1642a5f7ff8bad24953.png";